 
 
 
 
 
 
/**
 * It creates a foldable settings control panel over the map.
 *
 * @class ControlPanel
 * @namespace L
 * @extends L.Foldable
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.className="tomtom-control-panel"]
 * @param {String} [options.title=null] Title of the container. If it's null the title will be hidden.
 * @param {Object} [options.close]
 * @param {String} [options.close.text] Text displayed in the Close button
 * @param {String} [options.close.image="sdk/images/icon-cog.svg"] Image of the Close button
 * @param {Object} [options.show]
 * @param {String} [options.show.text] Text displayed in the Show button
 * @param {String} [options.show.image="sdk/images/icon-cog.svg"] Image of the Show button
 * @param {Boolean} [options.collapsed=true] Initial state of the foldable widget
 * 
 * @example
* ```javascript
* var results = [1, 2, 3];
* var widget = new L.ControlPanel();
* widget.addTo(map);
* widget.setContent('Length: ');
* widget.addContent(results.length);
* ```
 */
define(['display/map', 'widgets/controls/foldable'],
    function(L) {
        'use strict';

        var icons = {
            cog: L.Icon.Default.imagePath + '/icon-cog.svg'
        };

        L.ControlPanel = L.Foldable.extend({
            options: {
                className: 'tomtom-control-panel',
                title: null,
                close: { image: icons.cog },
                show: { image: icons.cog },
                collapsed: true
            }
        });

        return function(options) {
            return new L.ControlPanel(options);
        };
    }
);



// WEBPACK FOOTER //
// ./widgets/controls/controlPanel.js